import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './Dashboard';
import UsersList from './users/UsersList';
import UserForm from './users/UserForm';
import UserDetail from './users/UserDetail';
import PaymentsList from './payments/PaymentsList';
import PaymentDetails from './payments/PaymentDetails';
import ShipmentsList from './shipments/ShipmentsList';
import FedexTracking from './shipments/FedexTracking';
import ShipmentForm from './shipments/ShipmentForm';
import FedexShipmentsList from './fedex-shipments/FedexShipmentsList';
import FedexShipmentForm from './fedex-shipments/FedexShipmentForm';
import FedexShipmentDetail from './fedex-shipments/FedexShipmentDetail';
import ServicesList from './services/ServicesList';
import ServiceForm from './services/ServiceForm';
import CategoriesList from './categories/CategoriesList';
import CategoryForm from './categories/CategoryForm';
import ConsularActsList from './consular-acts/ConsularActsList';
import ConsularActForm from './consular-acts/ConsularActForm';
import Analytics from './Analytics';
import AdminHome from './AdminHome';

const Admin = () => {

  // Rendre le contenu de l'administration si l'utilisateur est authentifié
  return (
    <Routes>
      <Route path="/" element={<Dashboard />}>
        <Route index element={<AdminHome />} />
        
        {/* Routes pour les utilisateurs */}
        <Route path="users" element={<UsersList />} />
        <Route path="users/view/:id" element={<UserDetail />} />
        <Route path="users/new" element={<UserForm />} />
        <Route path="users/edit/:id" element={<UserForm />} />
        
        {/* Routes pour les paiements */}
        <Route path="payments" element={<PaymentsList />} />
        <Route path="payments/:id" element={<PaymentDetails />} />
        
        {/* Routes pour les expéditions */}
        <Route path="shipments" element={<ShipmentsList />} />
        <Route path="shipments/new" element={<ShipmentForm />} />
        <Route path="shipments/edit/:id" element={<ShipmentForm />} />
        
        {/* Routes pour les expéditions FedEx */}
        <Route path="fedex-shipments" element={<FedexShipmentsList />} />
        <Route path="fedex-shipments/new" element={<FedexShipmentForm />} />
        <Route path="fedex-shipments/edit/:id" element={<FedexShipmentForm />} />
        <Route path="fedex-shipments/:id" element={<FedexShipmentDetail />} />
        <Route path="fedex-tracking" element={<FedexTracking />} />
        
        {/* Routes pour les services */}
        <Route path="services" element={<ServicesList />} />
        <Route path="services/new" element={<ServiceForm />} />
        <Route path="services/edit/:id" element={<ServiceForm />} />
        
        {/* Routes pour les catégories */}
        <Route path="categories" element={<CategoriesList />} />
        <Route path="categories/new" element={<CategoryForm />} />
        <Route path="categories/edit/:id" element={<CategoryForm />} />
        
        {/* Routes pour les actes consulaires */}
        <Route path="consular-acts" element={<ConsularActsList />} />
        <Route path="consular-acts/new" element={<ConsularActForm />} />
        <Route path="consular-acts/edit/:id" element={<ConsularActForm />} />
        
        {/* Route pour les statistiques */}
        <Route path="analytics" element={<Analytics />} />
      </Route>
    </Routes>
  );
};

export default Admin;
